<button
  class="no-style toggle-icon no-select"
  aria-label="Toggle List View"
  [ngClass]="{ vertical: mode() === 'vertical' }"
  (click)="toggleIt()">
  @if (mode() === 'vertical') {
    <coin-anim-icon
      class="anim-arrow-icon"
      [svgIcon]="'arrows_down_white'"
      [hoverAnimate]="true"
      [startFrame]="27"
      [ngStyle]="{ transform: 'rotate(' + (isDefaultValue ? 90 : 270) + 'deg)' }"></coin-anim-icon>
  }
  @if (mode() === 'horizontal') {
    <coin-anim-icon
      class="anim-arrow-icon"
      [svgIcon]="'arrows_down_white'"
      [hoverAnimate]="true"
      [startFrame]="27"
      [ngStyle]="{
        transform: 'rotate(' + (isDefaultValue ? 0 : 180) + 'deg)',
        'margin-top': isDefaultValue ? '0px' : '-5px'
      }"></coin-anim-icon>
  }
</button>
